import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
//import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import BottomButtons from './BottomButtons';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import Modal from '@mui/material/Modal';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
//import BookIcon from '@mui/icons-material/Book';
import CheckIcon from '@mui/icons-material/Check';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {Owner} from './Inc';
//import {Tools} from './Tools';
import RowData from './RowData';
import Ajax from './Ajax';
import Loading from './Loading';
import Yesno from './Yesno';
import Title from './Title';


interface Props {
    owner:Owner,
    remove():void,
    logout():void,
}

const Bye = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        target:"",
        error:"",
        isLoading:false,
    });

    const confirm = (e: React.MouseEvent<HTMLElement>)=>{
        if( e.currentTarget.dataset.id ){
            setStates({...states,target:e.currentTarget.dataset.id});
        }
    }
    const yes = ()=>{
        if( states.target==="owner" ){
            removeOwner();
        }
        if( states.target==="customer" ){
            removeCustomer();
        }
    }
    const no = ()=>{
        setStates({...states,target:""});
    }

    const removeOwner = ()=>{
        setStates({...states,target:"",isLoading:true});
        Ajax.send("profile/remove",{},(res:any)=>{
            if( res.ok ){
                props.remove();
                setStates({...states,target:"",isLoading:false});
            } else {
                if( res.error!=="" ){
                    setStates({...states,target:"",error:res.error,isLoading:false});
                } else {
                    setStates({...states,target:"",error:"unknown",isLoading:false});
                }
            }
        });
    }
    const removeCustomer = ()=>{
        setStates({...states,target:"",isLoading:true});
        Ajax.send("main/remove",{customer_id:props.owner.customer.customer_id},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                props.logout();
            } else {
                if( res.error!=="" ){
                    setStates({...states,target:"",error:res.error,isLoading:false});
                } else {
                    setStates({...states,target:"",error:"unknown",isLoading:false});
                }
            }
        });        
    }
    const handleModalClose = ()=>{
        setStates({...states,target:"",error:"",isLoading:false});
    }

    useEffect( ()=>{
        window.scrollTo(0,0);
    } ,[]);

    const toFirst = "first/p5";

    let owner_name = "未登録";
    if( props.owner.owner_id>0 ){
        owner_name = props.owner.owner_name;
    }

    let mesYesno = "";
    if( states.target==="owner" ){
        mesYesno = "プロフィールを削除します。\nよろしいですか？";
    }
    if( states.target==="customer" ){
        mesYesno = "会員登録を削除します。\nよろしいですか？";
    }

	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9}>
                    <Paper className={classes.paper}>
                        <Title text="退会" icon="portrait"/>
                        <div className="firstTalk">
                            プロフィール（作家登録）および会員登録はこちらで削除できます。<br/>
                            今後お客様として買い物をしたい場合は、プロフィールだけ削除して会員登録を残しておくことも可能です。<br/>
                        </div>
                        <div className="steps">
                            <div className="stepList">
                                <Title text="退会までの手順" size={2}/>
                                <div className="stepBox">
                                    <h3>STEP.1　プロフィールの削除</h3>
                                    <div style={{marginBottom:"1em"}}>
                                        プロフィール（作家登録）を削除します。<br/>
                                    </div>
                                    <div style={{color:"#666666",fontSize:"80%"}}>
                                        ※商品在庫および売上残高が残っている場合は削除できません。<br/>
                                        ※削除したプロフィールを元に戻すことはできません。<br/>
                                    </div>
                                    <div className="stepBtn">
                                    {props.owner.owner_id>0 ? (
                                    <Button variant="contained" color="secondary" style={{width:"100%"}} onClick={confirm} data-id="owner" startIcon={<DeleteForeverIcon/>}>プロフィールを削除する</Button>
                                    ):(
                                    <div className="stepOK"><span className="withIcon"><CheckIcon/>削除済</span><br/><span style={{fontSize:"70%"}}>or 未登録</span></div>
                                    )}
                                    </div>
                                </div>
                                <div className="stepArrow">
                                    <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                </div>
                                <div className="stepBox">
                                    <h3>STEP.2　会員登録の削除</h3>
                                    <div style={{marginBottom:"1em"}}>
                                        会員登録を削除します。<br/>
                                    </div>
                                    <div style={{color:"#666666",fontSize:"80%"}}>
                                        ※お届けが完了していないご注文がある場合は削除できません。<br/>
                                        ※削除した会員登録を元に戻すことはできません。<br/>
										{props.owner.switch_id>1 && <span>※メインプロフィールに切り替えてから削除して下さい。</span>}
                                    </div>

                                    <div className="stepBtn">
                                    {(props.owner.owner_id>0 || props.owner.switch_id>1) &&
                                    <Button variant="contained" color="secondary" style={{width:"100%"}} disabled={true} startIcon={<DeleteForeverIcon/>}>会員登録を削除する</Button>
                                    }
                                    {props.owner.owner_id===0 && props.owner.customer.customer_id>0 && props.owner.switch_id===1 &&
                                    <Button variant="contained" color="secondary" style={{width:"100%"}} onClick={confirm} data-id="customer" startIcon={<DeleteForeverIcon/>}>会員登録を削除する</Button>
                                    }
                                    {props.owner.owner_id===0 && props.owner.customer.customer_id===0 &&
                                    <div className="stepOK"><span className="withIcon"><CheckIcon/>削除済</span><br/><span style={{fontSize:"70%"}}>or 未登録</span></div>
                                    }
                                    </div>
                                </div>
                                <div className="stepArrow">
                                    <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                </div>
                                <div className="stepBox">
                                    <h3>STEP.3　退会完了</h3>
                                    <div>
                                        架空ストアを再度ご利用になる場合は、会員登録からやり直して下さい。<br/>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Paper>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="作家名" value={owner_name}/>
                        <RowData name="会員名" value={props.owner.customer.name}/>
						<Divider style={{margin:"1em 0"}}/>
						<div>
							<div style={{color:'#666666'}}>メールアドレス</div>
							<div className={classes.yourMail}>{props.owner.customer.mail}</div>
						</div>
                        <Divider style={{margin:"1em 0"}}/>
                        <ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
                            <li>不明な点がございましたら「ご利用ガイド」をご覧いただくか、お問い合わせ下さい</li>
                        </ul>
                        <div style={{textAlign:'right'}}>
                            <Link to={toFirst}><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button></Link>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
            <Loading isLoading={states.isLoading}/>
            <Yesno mes={mesYesno} yes={yes} no={no} isOpen={mesYesno!==""}/>
			<Dialog
				open={states.error!==""}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				disableEscapeKeyDown={true}
				onClose={(event: object, reason: string) =>{
					if( reason!=="backdropClick" ){
						handleModalClose();
					}
				}}
			>
				<DialogTitle color="primary">削除できませんでした</DialogTitle>
				<DialogContent>
					{states.error==="owner" &&
					<>
						<div>メインプロフィール以外のプロフィールが残っています。まずはメインプロフィール以外から削除して下さい。</div>
						<BottomButtons button2='閉じる' onClick2={handleModalClose} bottom={0}/>
					</>
					}
					{states.error==="stock" &&
					<>
						<div>商品在庫が残っています。まずは商品引取の手続きを行って下さい。</div>
						<BottomButtons button1='商品引取' link1='/takeback' button2='閉じる' onClick2={handleModalClose} bottom={0}/>
					</>
					}
					{states.error==="payment" &&
					<>
						<div>売上残高が残っています。まずは支払申請の手続きを行って下さい。</div>
						<BottomButtons button1='支払申請' link1='/payment' button2='閉じる' onClick2={handleModalClose} bottom={0}/>
					</>
					}
					{states.error==="order" &&
					<>
						<div>お届けが完了していないご注文があります。商品到着までお待ち下さい。</div>
						<BottomButtons button1='閉じる' onClick1={handleModalClose} bottom={0}/>
					</>
					}
				</DialogContent>
			</Dialog>

		</div>
	);
}

export default Bye;
